import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import { NavLink } from 'react-router-dom'
import { store } from '../../store'

class Bibliography extends Component {
    componentDidMount() {
        if(this.props.bibliography.length === 0) {
            store.dispatch({type: 'LOADING', payload: {bibliography: true}})
        }
        window.gapi.load("client:auth2", function() {
            var API_KEY = "AIzaSyAcapzqeFF7hkveR9kQ934mMI8tX3iwSlc";
            var CLIENT_ID = ""; // TODO: Update placeholder with desired client ID.
            var SCOPE = "";
            window.gapi.client
                .init({
                    apiKey: API_KEY,
                    clientId: CLIENT_ID,
                    scope: SCOPE,
                    discoveryDocs: [
                        "https://sheets.googleapis.com/$discovery/rest?version=v4"
                    ]
                })
                .then(function() {
                    var params = {
                        spreadsheetId: "1ZtH2oRyCYot6vM0eqIctg2c24khybCmdK-672TNCWuU",
                        range: "Библиография!A:Z"
                    };
        
                    var request = window.gapi.client.sheets.spreadsheets.values.get(params);
                    request.then(
                        function(response) {
                            store.dispatch({
                                type: 'FETCH_BIBLIOGRAPHY_SUCCESS',
                                payload: response.result.values.slice(1).map(row =>
                                    response.result.values[0].reduce((acc, curr, i) => {
                                        acc[curr] = row[i];
                                        return acc;
                                    }, {})
                                )
                            })
                            store.dispatch({type: 'LOADING', payload: {bibliography: false}})

                        },
                        function(reason) {
                            store.dispatch({type:'ERROR', payload: reason.result.error.message});
                            store.dispatch({type: 'LOADING', payload: {bibliography: false}})
                        }
                    );
                });
        });
    }
    render() {
        const {bibliography} = this.props;
        return (
            <Fragment>
                <div id="accordion">
                    <div className="card mb-3">
                        <div className="card-header" id="headingOne">
                        <div className="mb-0">
                            <h3 data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Печатни съвременни книги на български език
                            </h3>
                        </div>
                        </div>
                        <div id="collapseOne" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                            <div className="card-body">
                                <ul className="list-group list-group-flush">
                                    {bibliography.filter(item => item['Категория'] === 'Печатни съвременни книги на български език').map((item, index) => {
                                        return (
                                            <li className="list-group-item"><strong>{item['Изследователи']}</strong> <span>{item['Изследвания']}</span></li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="card mb-3">
                        <div className="card-header" id="headingTwo">
                        <div className="mb-0">
                            <h3 data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                            Печатни съвременни книги на английски език
                            </h3>
                        </div>
                        </div>
                        <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                            <div className="card-body">
                                <ul className="list-group list-group-flush">
                                    {bibliography.filter(item => item['Категория'] === 'Печатни съвременни книги на английски език').map((item, index) => {
                                        return (
                                            <li className="list-group-item"><strong>{item['Изследователи']}</strong> <span>{item['Изследвания']}</span></li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="card mb-3">
                        <div className="card-header" id="headingThree">
                        <div className="mb-0">
                            <h3 data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                Електронни източници
                            </h3>
                        </div>
                        </div>
                        <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                            <div className="card-body">
                                <ul className="list-group list-group-flush">
                                    {bibliography.filter(item => item['Категория'] === 'Електронни източници').map((item, index) => {
                                        return (
                                            <li className="list-group-item"><strong>{item['Изследователи']}</strong> <span>{item['Изследвания']}</span></li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="card mb-3">
                        <div className="card-header" id="headingFour">
                        <div className="mb-0">
                            <h3 data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                Ръкописи
                            </h3>
                        </div>
                        </div>
                        <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#accordion">
                            <div className="card-body">
                                <ul className="list-group list-group-flush">
                                    {bibliography.filter(item => item['Категория'] === 'Ръкописи').map((item, index) => {
                                        return (
                                            <li className="list-group-item"><strong>{item['Изследователи']}</strong> <span>{item['Изследвания']}</span></li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="card mb-3">
                        <div className="card-header" id="headingFive">
                        <div className="mb-0">
                            <h3 data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                Приложения
                            </h3>
                        </div>
                        </div>
                        <div id="collapseFive" className="collapse" aria-labelledby="headingFive" data-parent="#accordion">
                            <div className="card-body">
                                <ul className="list-group list-group-flush">
                                    {bibliography.filter(item => item['Категория'] === 'Приложения').map((item, index) => {
                                        return (
                                            <li className="list-group-item"><strong>{item['Изследователи']}</strong> <span>{item['Изследвания']}</span></li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    bibliography:state.Bibliography
})

export default connect(mapStateToProps)(Bibliography);


// WEBPACK FOOTER //
// ./src/modules/Bibliography/container.js